import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { Core } from "@faire/design-tokens";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getSettingShipWithFaireEnabledCountries } from "@faire/help-center-utils/settings/getSettingShipWithFaireEnabledCountries";
import { BoldFormatting } from "@faire/help-center/components/utils/BoldFormatting";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { Lightbulb } from "@faire/web/slate/icons/foundation/Lightbulb";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useCountryName } from "../../hooks/useCountryName";
export var SWFBlurb = function SWFBlurb() {
  var _useSWFBlurbData = useSWFBlurbData(),
    isSWFAvailable = _useSWFBlurbData.isSWFAvailable,
    countryName = _useSWFBlurbData.countryName;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Lightbulb, {
    fontSize: "24px"
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "2x"
  }), isSWFAvailable ? ( /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "O8Wme4",
    defaultMessage: [{
      "type": 0,
      "value": "L’option Expédier avec Faire est disponible pour les marques de votre pays ("
    }, {
      "children": [{
        "type": 1,
        "value": "countryFullyTranslatedSentence"
      }],
      "type": 8,
      "value": "boldFormatting"
    }, {
      "type": 0,
      "value": ")."
    }],
    values: {
      countryFullyTranslatedSentence: countryName,
      boldFormatting: BoldFormatting
    }
  }))) : ( /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hD1FrG",
    defaultMessage: [{
      "type": 0,
      "value": "L'option Expédier avec Faire n'est pas disponible pour les marques de votre pays ("
    }, {
      "children": [{
        "type": 1,
        "value": "countryFullyTranslatedSentence"
      }],
      "type": 8,
      "value": "boldFormatting"
    }, {
      "type": 0,
      "value": ")."
    }],
    values: {
      countryFullyTranslatedSentence: countryName,
      boldFormatting: BoldFormatting
    }
  }))));
};
var useSWFBlurbData = function useSWFBlurbData() {
  var brand = getBrand();
  var brandShipsFromCountryISO = getBrandShipsFromCountryISO(brand);
  var isSWFAvailable = getIsSWFAvailable(brandShipsFromCountryISO);
  var countryName = useCountryName(brandShipsFromCountryISO);
  return {
    isSWFAvailable: isSWFAvailable,
    countryName: countryName
  };
};
var getBrandShipsFromCountryISO = function getBrandShipsFromCountryISO(brand) {
  var _brand$ships_from_cou;
  return (_brand$ships_from_cou = brand === null || brand === void 0 ? void 0 : brand.ships_from_country) !== null && _brand$ships_from_cou !== void 0 ? _brand$ships_from_cou : ISO3166Alpha3.ISO3166ALPHA3_UNKNOWN;
};
var getIsSWFAvailable = function getIsSWFAvailable(brandShipsFromCountryISO) {
  return getSettingShipWithFaireEnabledCountries().includes(brandShipsFromCountryISO);
};
var Wrapper = styled(Row).attrs({
  justify: "center",
  align: "center"
}).withConfig({
  displayName: "SWFBlurb__Wrapper"
})(["background-color:", ";padding:", ";"], Core.surface.subdued, getSpacing("3x"));